import { Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client'
import Homepage from './Homepage';
import Gamepage from "./Gamepage"
import Background from './components/Background';
import Matchmake from './components/Matchmake';
import './styles/App.css';

function App() {
  const [socket, setSocket] = useState(null);


  // On Render set up socket connection
  useEffect(() => {
    try {
      if (socket === null) {
        setSocket(io('https://reversiapi.idkuri.com'))
      }
    }
    catch (error) {
      alert(error)
    }
  }, [socket])

  return (
    <>
      <Background/>
      <Routes>
        <Route path ="/" element={<Homepage socket={socket}/>}/> {/* Homepage is the landing page */}
        <Route path ="/:gameId" element={<Gamepage socket={socket}/>}/> {/* Gamepage is the game page */}
      </Routes>
    </>
  );
}

export default App;
